import React from 'react';

export const fmtInt = (n) =>
  n == null || Number.isNaN(n) ? '—' : new Intl.NumberFormat('fr-FR').format(n);

export const fmtPct = (n) =>
  n == null || Number.isNaN(n) ? '—' : `${Number(n).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} %`;

export const fmtDateFr = (iso) => {
  if (!iso || typeof iso !== 'string') return '—';
  const [y, m, d] = iso.slice(0, 10).split('-');
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
};

export const BarRow = ({ label, value, max, color, mutedColor }) => {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div className="flex items-center gap-2 sm:gap-3 text-sm">
      <span
        className="w-24 sm:w-32 shrink-0 truncate font-medium"
        style={{ color: mutedColor }}
        title={label}
      >
        {label}
      </span>
      <div className="flex-1 h-2 rounded-full overflow-hidden bg-black/5 dark:bg-white/10">
        <div
          className="h-full rounded-full transition-[width] duration-300"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
      <span className="w-14 text-right tabular-nums font-medium">{fmtInt(value)}</span>
    </div>
  );
};

export const Kpi = ({ title, value, subtitle, theme }) => (
  <div
    className="rounded-xl border px-3 py-3 sm:px-4 sm:py-3.5 shadow-sm/50"
    style={{
      backgroundColor: theme.surface,
      borderColor: theme.border,
      boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    }}
  >
    <p
      className="text-[10px] sm:text-xs font-semibold uppercase tracking-wide leading-tight"
      style={{ color: theme.textSecondary }}
    >
      {title}
    </p>
    <p className="text-xl sm:text-2xl font-semibold tabular-nums mt-0.5 leading-tight" style={{ color: theme.text }}>
      {value}
    </p>
    {subtitle ? (
      <p className="text-[11px] sm:text-xs mt-1 leading-snug line-clamp-2" style={{ color: theme.textSecondary }}>
        {subtitle}
      </p>
    ) : null}
  </div>
);
